import React from 'react';
import Modal from 'react-modal';
import IconButton from '../../../Button/IconButton';
import BurgerIcon from '../../../Icons/Burger';
import NetworkBar from '../../../NetworkBar';
import s from './BurgerMenu.scss';
var BurgerMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, _b = _a.showNetworkBar, showNetworkBar = _b === void 0 ? true : _b, isBurgerMenuOpen = _a.isBurgerMenuOpen, toggleBurgerMenu = _a.toggleBurgerMenu;
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { onClick: function () { return toggleBurgerMenu(!isBurgerMenuOpen); }, className: className },
            React.createElement(BurgerIcon, { disableDefaultColors: true, className: iconClassName })),
        showNetworkBar && (React.createElement(Modal, { isOpen: isBurgerMenuOpen, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, className: s['modal-root'], overlayClassName: s['overlay'], onRequestClose: function () { return toggleBurgerMenu(false); } },
            React.createElement(NetworkBar, null)))));
};
BurgerMenu.displayName = 'BurgerMenu';
export default BurgerMenu;
//# sourceMappingURL=BurgerMenu.js.map